module.exports = __webpack_public_path__ + "static/media/douce_ambiance.89f77a45.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/recordings/douce_ambiance.mp3
// module id = 51
// module chunks = 0